import { APP_ENV } from "../config/constants";

export const meaVanaConsole = (text, value = "") => {
  if (APP_ENV === "development") {
    console.log(text, value);
  }
};
